import { render } from "./PptEdit.vue?vue&type=template&id=777a5922"
import script from "./PptEdit.vue?vue&type=script&lang=js"
export * from "./PptEdit.vue?vue&type=script&lang=js"
script.render = render

export default script